import React from 'react';
import LoginPage from './LoginPage';
import useDashboardAuth from '../hooks/useDashboardAuth';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading, login } = useDashboardAuth();

  // Show loading spinner while checking authentication
  if (loading) {
    return (
      <div style={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'white',
        fontFamily: 'Segoe UI, Tahoma, Geneva, Verdana, sans-serif'
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{
            width: '50px',
            height: '50px',
            border: '4px solid rgba(255, 255, 255, 0.3)',
            borderTop: '4px solid white',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            margin: '0 auto 1rem'
          }}></div>
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  // Show login page if not authenticated
  if (!isAuthenticated) {
    return (
      <LoginPage 
        onLoginSuccess={() => {
          // The auth state will be updated by the hook
          window.location.reload(); // Simple way to refresh the app state
        }} 
      />
    );
  }

  // Show protected content if authenticated
  return children;
};

export default ProtectedRoute;
